import { FileDataModel, FileResponse } from "../services/api-services";

export default class DownloadHelper {
  public static downloadFile(data: FileResponse | null): void {
    const blob: any = new Blob([data?.data!], { type: `${data?.fileName!}; charset=utf-8` });

    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.setAttribute('download', data?.fileName!);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  public static downloadFileFromUrl(url: string, fileName: string): void {
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.setAttribute('download', fileName);
    document.body.appendChild(downloadLink);
    downloadLink.click();
  }

  public static downloadFileFromDataModel(data: FileDataModel): void {
    const binaryString = window.atob(data.data!);

    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: data.contentType });
    const url = window.URL.createObjectURL(blob);

    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.setAttribute('download', data?.filename!);
    document.body.appendChild(downloadLink);
    downloadLink.click();

    document.body.removeChild(downloadLink);
    window.URL.revokeObjectURL(url);
  }
}
